import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import PropTypes from 'prop-types';

import { Copyright } from '../../Copyright';
import { ContactsFinantech } from './Contacts';
import {
  CompanyInfoStyled,
  DescriptionStyled,
  FooterStyled,
  IconStyled,
} from './FooterFinantech.styles';
import { SocialNetworksFinantech } from './SocialNetworks';

export const FooterFinantech = ({ id, className }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const theme = useTheme();

  return (
    <>
      <FooterStyled id={id ?? 'footer'} className={className ?? null}>
        {!isMobile && (
          <CompanyInfoStyled>
            <IconStyled iconI={theme.customLogo.clogo} />
            <DescriptionStyled>
              Sorem ipsum dolor sit amet consectetur adipiscing elit dapibus non
              apte magna ad suspendisse nec pulvi.
            </DescriptionStyled>
            <SocialNetworksFinantech />
          </CompanyInfoStyled>
        )}
        <ContactsFinantech />
        {isMobile && <SocialNetworksFinantech />}
      </FooterStyled>

      <Copyright />
    </>
  );
};

FooterFinantech.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
};
